import React, {useContext, useMemo} from "react";

import AssessmentDeliveryContext from "../AssessmentDeliveryContext";
import CustomTreeItem from "./CustomTreeItem";
import ExerciseNavItem from "./ExerciseNavItem";
import type LabelProps from "./LabelProps";
import {useAppSelector} from "../../store/hooks";

function SectionNavItem(props: {
	courseId: number;
	sectionKey: string;
	index: string;

	renderExerciseLabel: (
		exerciseId: number,
		params: LabelProps
	) => React.ReactNode;
	renderLabel: (itemId: string, params: LabelProps) => React.ReactNode;

	defineItemType?: (
		sectionKey: string
	) => {
		highlighted?: boolean;
	};
	defineExerciseItemType?: () => {
		clickable: boolean;
	};
}) {
	const {makeSelectSection, selectSubsectionKeys} = useContext(
		AssessmentDeliveryContext
	);

	const selectSection = useMemo(makeSelectSection, [makeSelectSection]);

	const subsections = useAppSelector((state) =>
		selectSubsectionKeys(state, props.sectionKey)
	);

	const section = useAppSelector((state) =>
		selectSection(state, props.sectionKey)
	);

	if (!section) {
		return <></>;
	}

	const style = props.defineItemType?.(props.sectionKey);

	return (
		<CustomTreeItem
			itemId={props.sectionKey}
			label={props.renderLabel(props.sectionKey, {
				index: props.index,
				text: section.title,
			})}
			clickable={subsections.length > 0}
			highlighted={style?.highlighted}
			slotProps={{iconContainer: {style: {marginTop: `calc(0.715rem - 9px)`}}}}
		>
			{subsections.map((key: string, i: number) => (
				<ExerciseNavItem
					key={key}
					index={`${props.index}.${i + 1}`}
					exerciseKey={key}
					renderLabel={props.renderExerciseLabel}
					defineItemType={props.defineExerciseItemType}
				/>
			))}
		</CustomTreeItem>
	);
}

export default SectionNavItem;
